export enum OperatingSystemArchitecture {
  X64 = 'x64',
  Arm64 = 'arm64',
}
